import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/common/header/Header';
import Sidebar from './components/common/sidebar/Sidebar';
import { useSidebar } from './context/SidebarContext';
import { AppProviders } from './providers/AppProviders';
import AppRoutes from './routes';
import './styles/appStyles.css';

/** Inner shell: must render under SidebarProvider (uses useSidebar for layout class). */
const AppLayout = () => {
  const location = useLocation();
  const { isSidebarOpen } = useSidebar();
  const isLoginPage = location.pathname === '/';
  const isLandingPage = location.pathname === '/dashboard';
  const showSidebarChrome = !isLoginPage && !isLandingPage;

  const containerClassName = [
    'container',
    (isLoginPage || isLandingPage) ? 'login-container' : '',
    showSidebarChrome && !isSidebarOpen ? 'sidebar-closed' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className="App">
      {!isLoginPage && <Header />}
      <div className={containerClassName}>
        {showSidebarChrome && <Sidebar />}
        <AppRoutes />
      </div>
    </div>
  );
};

const AppContent = () => (
  <AppProviders>
    <AppLayout />
  </AppProviders>
);

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
